import React from 'react';
import { Box, Heading, VStack } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { FirstStepTaskOverlay } from 'components/TaskOverlay/FirstStepTaskOverlay';
import { TaskOverlayBody } from 'components/TaskOverlay';

const ModalContentPadding = {
  pt: 4,
  pb: 4,
  pr: 6,
  pl: 6,
};

export interface ChooseTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  availableTemplates: React.ReactNode[];
}

export default function ChooseTemplateModal({
  isOpen,
  onClose,
  availableTemplates,
}: ChooseTemplateModalProps) {
  return (
    <FirstStepTaskOverlay isOpen={isOpen} onClose={onClose}>
      <Box {...ModalContentPadding}>
        <Heading as="h4" size="md">
          {t`Choose a Template`}
        </Heading>
      </Box>
      <TaskOverlayBody pt={4}>
        <VStack py={4} align="flex-start">
          {availableTemplates.map((template, index) => {
            return <React.Fragment key={index}>{template}</React.Fragment>;
          })}
        </VStack>
      </TaskOverlayBody>
    </FirstStepTaskOverlay>
  );
}
